import { useEffect, useRef } from "react";
import $ from "jquery";
import useUserStore from "../../utils/storeApp";

const GcpUnavailableModal = () => {

    const closeBtnRef = useRef(null);
    const { gcpFeatureUnavailable, setGcpFeatureUnavailable } = useUserStore((state) => ({
        gcpFeatureUnavailable: state.gcpFeatureUnavailable,
        setGcpFeatureUnavailable: state.setGcpFeatureUnavailable,
    }));

    useEffect(() => {
        const modalEl = document.getElementById("GcpUnavailableModal");
        if (!modalEl) return;
        const onShown = () => setTimeout(() => closeBtnRef.current?.focus(), 50);
        modalEl.addEventListener("shown.bs.modal", onShown);
        return () => modalEl.removeEventListener("shown.bs.modal", onShown);
    }, []);

    useEffect(() => {
        if (gcpFeatureUnavailable) {
            $('#GcpUnavailableModal').modal('show');
        }
    }, [gcpFeatureUnavailable]);

    const CloseModal = () => {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }

        $('#GcpUnavailableModal').modal('hide');
        setGcpFeatureUnavailable(false);
    };

    return (
        <div className="GcpUnavailableModal">
            <div
                className="modal fade"
                id="GcpUnavailableModal"
                data-backdrop="static"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="GcpUnavailableModalTitle"
                aria-describedby="gcpUnavailableModalDesc"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title" id="GcpUnavailableModalTitle">Feature Unavailable</h3>
                            <button
                                type="button"
                                className="close"
                                aria-label="Close"
                                onClick={CloseModal}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p
                                className="message-wrapper"
                                id="gcpUnavailableModalDesc"
                                role="status"
                                aria-live="polite"
                                aria-atomic="true"
                            >
                                The functionality is not yet available.
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={CloseModal}
                                ref={closeBtnRef}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default GcpUnavailableModal;